import { InjectionToken } from '@angular/core';

import { type FunctionScope } from '@blaze-shared/api-contracts-domain';

export const INTELLI_FUNCTIONS_SCOPE_TOKEN = new InjectionToken<FunctionScope>(
  'INTELLI_FUNCTIONS_SCOPE_TOKEN',
);
